import axios from 'axios';
import { endPoint } from '../utils/Utils';

function header() {
    const token = localStorage.getItem('token');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
    return { headers };
}


export async function getBranch() {
    return new Promise((resolve, reject) => {
        axios.get(`${endPoint}/branch-tax-config`, header()).then(response => {
            resolve(response.data);
        }).catch(err => {
            console.log(err);
            resolve({});
        })
    })
}
